import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './App.css'
import './index.css';
ReactDOM.createRoot(document.getElementById('root')).render(
  
    <App />
 
)
